module.exports = __webpack_public_path__ + "img/login_biaoti7.c9b5a48d.png";